import { runJsonGet, runJsonPut } from '@/backend-client'
import { OPERATIONS_BACKEND_URL } from '@/config'
import { transformKeysToCamelCase, transformKeysToSnakeCase } from './utils/casing'

export const fetchCarrierInvoicingTerms = async (params?: any) => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/ordering-carrier/queries/carrier-company/by-person`,
    transformKeysToSnakeCase(params)
  )
  return transformKeysToCamelCase(data)
}

export const fetchPersonDetails = async (params?: any) => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/accounts/persons/me`,
    transformKeysToSnakeCase(params)
  )
  return transformKeysToCamelCase(data)
}
export const paymentPeriodOptions: any = async () => {
  const { data } = await runJsonGet(
    `${OPERATIONS_BACKEND_URL}/finance/queries/get-payment-term-options`
  )
  return transformKeysToCamelCase(data)
}

export const updateCarrierInvoicingTerms = async (id, payload) => {
  const { data } = await runJsonPut(
    `${OPERATIONS_BACKEND_URL}/finance/commands/${id}/update-payment-days`,
    transformKeysToSnakeCase(payload)
  )
  return transformKeysToCamelCase(data)
}

export const updateLastShownPaymentPopUpDate = async payload => {
  const { data } = await runJsonPut(
    `${OPERATIONS_BACKEND_URL}/accounts/persons/me`,
    transformKeysToSnakeCase(payload)
  )
  return transformKeysToCamelCase(data)
}
